<template>

<div class="leftmenu leftmenu-global">

    <ul class="expandmenu">
        <li v-for="(i1,i1_i) in menu" :key="'i1'+i1_i">
            <router-link v-if="i1.to" :to="i1.to">{{i1.label}}</router-link>            
            <div class="as-link" v-if="i1.click" @click="i1.click">{{i1.label}}</div>
            
            <div v-if="i1.subitems" class="sub" :class="{'open':menuSubsOpen[i1.key]}">
                <div class="title" @click="toggleMenuSubOpen(i1,null,menu)">{{i1.label}}</div>
                
                <transition-expand>
                <ul v-if="menuSubsOpen[i1.key]">
                    <li v-for="(i2,i2_i) in i1.subitems" :class="{'open':menuSubsOpen[i2.key]}" :key="'i2'+i2_i">
                        <router-link v-if="i2.to" :to="i2.to">{{i2.label}}</router-link>
                        <div class="as-link" v-if="i2.click" @click="i2.click">{{i2.label}}</div>
                        
                        <div v-if="i2.subitems" class="sub" :class="{'open':menuSubsOpen[i2.key]}">
                            <div class="title" @click="toggleMenuSubOpen(i2,i1,menu)">{{i2.label}}</div>
                            
                            <transition-expand>
                            <ul v-if="menuSubsOpen[i2.key]">
                                <li v-for="(i3,i3_i) in i2.subitems" :key="'i3'+i3_i">
                                    
                                    <router-link v-if="i3.to" :to="i3.to">{{i3.label}}</router-link>
                                    <div class="as-link" v-if="i3.click" @click="i3.click">{{i3.label}}</div>

                                </li>
                            </ul>   
                            </transition-expand>    
                        </div>                                     

                    </li>
                </ul>   
                </transition-expand>
            </div>                  

        </li>
    </ul>
    
</div>

</template>
<script>
import mixins from '.././mixins.js'
import TransitionExpand from '.././components/TransitionExpand.vue'

export default {
	
    mixins: [ mixins.generic ],
    
    props: [ 'baseclass' ],
	
	components: { 		
		TransitionExpand,
	},

	data(){ return {
			
        menuSubsOpen: {},

	}},

	computed: {        

        menu(){
            
            var menu_scoop = [
                { label:'Models', key:'fsdgfdg', subitems:[
                    { label:'Women', key:'sfsadff', subitems:[
                        { label:'New Face', to:'/models/women/new-face' },
                        { label:'Image', to:'/models/women/image' },
                        { label:'Image Direct', to:'/models/women/image-direct' },
                        { label:'Mainboard', to:'/models/women/mainboard' },
                        { label:'Mainboard Direct', to:'/models/women/mainboard-direct' },
                        { label:'Forever', to:'/models/women/forever' },
                        //{ label:'Forever Direct', to:'/models/women/forever-direct' },
                        { label:'All', to:'/models/women/all_boards' },
                    ] },
                    { label:'Men', key:'dfgge', subitems:[
                        { label:'New Face', to:'/models/men/new-face' },
                        { label:'Image', to:'/models/men/image' },
                        { label:'Image Direct', to:'/models/men/image-direct' },
                        { label:'Mainboard', to:'/models/men/mainboard' },
                        { label:'Mainboard Direct', to:'/models/men/mainboard-direct' },
                        { label:'Forever', to:'/models/men/forever' },
                        //{ label:'Forever Direct', to:'/models/men/forever-direct' },
                        { label:'All', to:'/models/men/all_boards' },
                    ] },
                    { label:'Streetcast', to:'/models/streetcast' },
                    { label:'Special Arrangement', key:'dfgdsge', subitems:[
                        { label:'Prince Nikolai', to:'/model/prince-nikolai-1' },
                        { label:'Music', to:'/models/special-arrangement-music' },
                        { label:'Acting', to:'/models/special-arrangement-acting' },
                        { label:'Sport', to:'/models/special-arrangement-sport' },
                        //{ label:'All', to:'/models/special-arrangement' },    
                    ] },
                    //{ label:'Search', click:this.open_findbox },
                    { label:'Search', to:'/model-search' },
                    { label:'Package', to:'/package' },
                ] },
                { label:'News', key:'fsdsg', subitems:[
                    { label:'News', to:'/news' },
                    { label:'Go-see/Instax', to:'/go-see' },
                    { label:'Love Is Not A Crime', to:'/love-is-not-a-crime' },
                    { label:'Follow us', to:'/follow-us' },
                ] },
                { label:'Contact', key:'y5sf', subitems:[
                    { label:'Contact', to:'/contact' },
                    { label:'Become a model', to:'/become-a-model' },
                    { label:'About', to:'/about' },
                    { label:'Body and mind', to:'/body-and-mind' },
                    { label:'Location', to:'/location' },
                    { label:'Jobs', to:'/jobs' },
                ] },
            ]

            var menu_social = [
                { label:'News', key:'d2d2', subitems:[
                    { label:'News', to:'/social', },
                    { label:'Follow us', to:'/social/follow-us' },
                ] },                
                { label:'Influencers', key:'gsgegd', subitems:[
                    { label:'Main Influencers', to:'/social/influencers/main' },
                    { label:'Image Influencers', to:'/social/influencers/image' },
                    { label:'Model Influencers', to:'/social/influencers/model' },
                    //{ label:'Package', to:'/social/package' },
                ] },
                { label:'Contact', key:'fsd', subitems:[
                    { label:'Contact', to:'/social/contact' },
                    { label:'About', to:'/social/about' },
                    { label:'Location', to:'/social/location' },                    
                ] },
            ]
            
            var menu = menu_scoop
            if( this.is_site_scoopsocial ) menu = menu_social
                        
            if( false && this.loggedin_user ) {
                menu.push({ label:'Admin', to:'/admin', if:this.loggedin_user, },)
                if( this.loaded_page_id ) {
                    menu.push({ label:'Edit page', to: '/admin/page/' + this.loaded_page_id, })                    
                }
                if( this.editable_layoutblocks ) {
                    menu.push({ label:'Edit layout', click: this.editLayout, },)
                }

            }

            return menu

        },


        toggled_open(){ return this.$store.state.leftbar_main_toggled_open },
        
        is_toggled_women(){ return ( this.route.parts[1] == 'women' ) },
        is_toggled_men(){ return ( this.route.parts[1] == 'men' ) },

        rp(){ return this.route.path },

        show_admin_page_edit_btn(){
            if( !this.$store.state.loaded_page ) return false
            var a = '/' + this.$store.state.loaded_page.slug
            var b = this.rp
            
            var match = ( a == b )
            return match
        },

	},

	methods: {

        toggleMenuSubOpen(item,item_parent,menu){
            
            //var initial_open = item.open

            if(this.menuSubsOpen[item.key] == undefined) this.$set( this.menuSubsOpen, item.key, false )

            var initial_open = this.menuSubsOpen[item.key]

            var _this = this

            // close all
            menu.forEach(function(i1){
                
                //i1.open = false
                _this.$set( _this.menuSubsOpen, i1.key, false )

                if(i1.subitems) {
                    i1.subitems.forEach(function(i2){
                        
                        //i2.open = false           
                        _this.$set( _this.menuSubsOpen, i2.key, false )

                    })
                }
            })

            //item.open = !initial_open
            //_this.menuSubsOpen[item.key] = !initial_open
            _this.$set( _this.menuSubsOpen, item.key, !initial_open )            

            if(item_parent) _this.$set( _this.menuSubsOpen, item_parent.key, true )
            
        },

        // run this on init
        setMenuSubsOpen(menu){
            
            var rp = this.$store.state.route.current.path

            var _this = this

            this.menu.forEach(function(i1,i){
                
                if(i1.subitems) {
                    i1.subitems.forEach(function(i2){
                        
                        //if ( i2.to && i2.to == rp ) i1.open = true
                        if ( i2.to && i2.to == rp ) _this.$set( _this.menuSubsOpen, i1.key, true )

                        if(i2.subitems) {
                            i2.subitems.forEach(function(i3){
                                
                                if( i3.to && i3.to == rp ) {
                                    
                                    //i1.open = true
                                    //i2.open = true                                    
                                    _this.$set( _this.menuSubsOpen, i1.key, true )
                                    _this.$set( _this.menuSubsOpen, i2.key, true )

                                }                                

                            })
                        }

                    })
                }
            })

        },

        toggle(lvl,key){
            var toggled = !this.isToggled(lvl,key)
            this.$store.commit('leftbar_main_toggle_open', { lvl, key, toggled })

            return
            for( var lvl in this.$store.state.leftbar_main_toggled_open ) {
                if( lvl != lvl ) continue
                //if( this.$store.state.leftbar_main_toggled_open[ lvl ][] )
            }
        },
        
        isToggled(lvl,key){
            if( this.toggled_open[lvl] == undefined ) return false
            if( this.toggled_open[lvl][key] == undefined ) return false
            if( this.toggled_open[lvl][key] && this.toggled_open[lvl][key] === true ) return true
            return false
        },

        
        link_cls(path){
            var cls = {}
            if( this.rp_is(path) ) cls.current = true
            return cls
        },

        rp_is(path){
            if( '/' + path == this.rp ) return true
            return false
        },

        rp_in(paths){
            for( var i = 0; i < paths.length; i++ ) {
                var path = paths[i]
                if( this.rp_is(path) ) return true
            }
            return false
        },

        open_findbox(){
            this.$store.commit('set_off_canvas_menu_active',false)
            this.findbox_open()            
        },

	},

	created(){
		
    },
    
    mounted(){

        this.setMenuSubsOpen(this.menu)

    },

}
</script>



// WEBPACK FOOTER //
// src/views/LeftMenu.vue